import { render, staticRenderFns } from "./TablaTrabajadoresDocumentos.vue?vue&type=template&id=08ae3599&scoped=true"
import script from "./TablaTrabajadoresDocumentos.vue?vue&type=script&lang=js"
export * from "./TablaTrabajadoresDocumentos.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TablaTrabajadoresDocumentos.vue?vue&type=style&index=1&id=08ae3599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae3599",
  null
  
)

export default component.exports